import { jsx as e, jsxs as o, Fragment as i } from "react/jsx-runtime";
import f from "react";
import { c as O } from "./index.CWkFp9WS.js";
import { S } from "./index.J3BKoY__.js";
import { O as k } from "./ODSIcon.DjL6Q3o4.js";
import '../assets/ODSGlobalHeaderMetaLink.css';const M = f.forwardRef((n, t) => {
  const {
    label: c,
    external: a,
    assistiveMessageExternal: d = "opens in new tab",
    asChild: s,
    children: m,
    className: p,
    ...b
  } = n, h = s ? S : "a", r = a ? "external-link" : n.icon, l = a ? /* @__PURE__ */ e("span", { className: "sr-only", children: d }) : null;
  return /* @__PURE__ */ e(
    h,
    {
      ref: t,
      className: O("ODSGlobalHeaderMetaLink", p, {
        "ODSGlobalHeaderMetaLink--has-icon": r != null
      }),
      target: a ? "_blank" : void 0,
      rel: a ? "noopener noreferrer" : void 0,
      role: "menuitem",
      ...b,
      children: s ? /* @__PURE__ */ o(i, { children: [
        m,
        l
      ] }) : /* @__PURE__ */ o(i, { children: [
        /* @__PURE__ */ e("span", { className: "ODSGlobalHeaderMetaLink-Label", children: c }),
        l,
        r && /* @__PURE__ */ e("span", { className: "ODSGlobalHeaderMetaLink-Icon", "aria-hidden": "true", children: /* @__PURE__ */ e(k, { name: r, size: 16, decorative: !0 }) })
      ] })
    }
  );
});
M.displayName = "ODSGlobalHeaderMetaLink";
export {
  M as O
};
//# sourceMappingURL=ODSGlobalHeaderMetaLink.D4w98_mR.js.map
